<template>
  <div class="booking-menu">
    <v-flex pa-2>
      <p v-html="tooltipForTaxi(taxi)"></p>
    </v-flex>
    <ul style="cursor: pointer; padding-left: 0px !important;">
      <li v-if="" class="padding-li" key="editBooking" @click="editBooking" >
        <p style="padding-right: 12px;">Edit Booking</p>
      </li>
      <li class="padding-li" key="message" @click="message">
        <p style="padding-right: 12px;">Message Driver</p>
      </li>
      <li class="padding-li">
        <a :href="'tel:' + formatNumber(taxi.driver.contact_number)">
          <p>Call Driver {{ formatNumber(taxi.driver.contact_number) }}</p>
        </a>
      </li>
      <li class="padding-li" @click="openTaxiFollowOnJobsDialog">
        <p style="padding-right: 12px;" >Follow On Jobs</p>
      </li>
      <li class="padding-li" key="logout" @click="logout">
        <p style="padding-right: 12px; color: red;">Logout Driver</p>
      </li>
    </ul>
    <v-dialog v-model="messageDialog" width="600px">
      <MessageDriverDialog @sent="messageDialog = false" :taxi="taxi" />
    </v-dialog>
    <div class="text-center">
      <v-dialog
        v-model="taxiFollowOnJobsDialog"
        width="800"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Follow On Jobs <v-chip color="primary" small class="mx-3">
            <v-icon small class="ma-1">mdi-car</v-icon>
            {{taxi.driver.callsign}}
          </v-chip>
            <v-spacer></v-spacer>
            <v-icon @click="taxiFollowOnJobsDialog = false">mdi-close</v-icon>
          </v-card-title>
        
          <v-card-text>
            <TaxiFollowOnJobsList :taxi="taxi"></TaxiFollowOnJobsList>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { replaceStart } from "@/components/util/PhoneNumbers.js";

import { Overwatch } from "@/components/util/Overwatch.js";

import MessageDriverDialog from "@/components/widget/menu/MessageDriverDialog.vue";
import TaxiFollowOnJobsList from '@/components/booking/active_jobs/TaxiFollowOnJobsList'

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;


export default {
  components: {
    TaxiFollowOnJobsList,
    MessageDriverDialog
  },
  name: "DriverMenu",
  props: {
    taxi: Object
  },
  data() {
    return {
      mode: null,
      loading: false,
      messageDialog: false,
      taxiFollowOnJobsDialog: false
    };
  },
  mounted: function() {
    // console.log(this.booking);
  },
  methods: {
    logout () {
      var url = `${this.$store.state.apiUrl}/overwatch/logoutTaxi?taxi_id=${this.taxi.id}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            console.log("Success");
            alert("Success");
          } else {
            alert("Failed");
          }
        })
        .catch(function(err) {
          alert("Error " + err);
          this.loading = false;
        });
    },
    openTaxiFollowOnJobsDialog () {
      this.$store.dispatch('followOnJob/getFollowOnJobsForTaxi', this.taxi.id)
      this.taxiFollowOnJobsDialog = true
    },
    editBooking: function() {
      this.$emit("editBooking")
    },
    message: function() {
      if (this.taxi.driver.chat_enabled == true) {
        this.$store.state.driverToMessage = this.taxi.driver.id;
        this.$store.state.driverToMessageName = this.taxi.driver.name;
        console.log(this.taxi.driver.id);
      } else {
        this.messageDialog = true;
      }
    },
    formatNumber: function(number) {
      return replaceStart(number);
    },
    tooltipForTaxi: function(taxi) {
      var ow = new Overwatch(this.taxis, this.bookings);
      return ow.tooltipForTaxi(taxi);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.booking-menu {
  background-color: white;
}

.confirm-container {
  padding: 12px;
}

.padding-li {
  padding-right: 12px;
}
</style>
